export var ValidationErrorStatusEnum;
(function (ValidationErrorStatusEnum) {
    ValidationErrorStatusEnum["UNHANDLED"] = "UNHANDLED";
    ValidationErrorStatusEnum["MENU_MISMATCH"] = "MENU_MISMATCH";
    ValidationErrorStatusEnum["PRICE_DISCREPANCY"] = "PRICE_DISCREPANCY";
})(ValidationErrorStatusEnum || (ValidationErrorStatusEnum = {}));
//# sourceMappingURL=ValidationErrorStatusEnum.js.map